exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".VNbxVk_b-RvlGE{display:flex;flex-direction:row;justify-content:space-between;margin-bottom:16px}.VNbxVk_b-RvlGE button{width:136px;margin:0}.VNbxVk_b-RvlGE button._3BWxS0tAkl2Grq{background:#8bbdd9}._315-_DLFVOeT1z{margin-bottom:8px}._1U1i9FD2yvyIJQ{display:none;text-align:right;color:#5e6c84;margin-top:-8px}._1U1i9FD2yvyIJQ._3pEm3B7ambAiiR{display:block}.PH7wx8pjLrW-wW{resize:none;height:80px}.mDUv-z75w6Y9wf{width:100%}", ""]);

// exports
exports.locals = {
	"useful": "VNbxVk_b-RvlGE",
	"selected": "_3BWxS0tAkl2Grq",
	"question": "_315-_DLFVOeT1z",
	"lengthWarning": "_1U1i9FD2yvyIJQ",
	"show": "_3pEm3B7ambAiiR",
	"freeform": "PH7wx8pjLrW-wW",
	"submit": "mDUv-z75w6Y9wf"
};